module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Atsakykite į kelis|klausimus ir gaukite|Nogrid pasiūlymą!"}}')
  delete Component.options._Ctor
}
